export default __webpack_public_path__ + "static/media/appstore.c4d6284c.png";